var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.791748 9.50002C0.791748 9.50002 3.95842 3.16669 9.50008 3.16669C15.0417 3.16669 18.2084 9.50002 18.2084 9.50002C18.2084 9.50002 15.0417 15.8334 9.50008 15.8334C3.95842 15.8334 0.791748 9.50002 0.791748 9.50002Z",
    stroke: "#BACCE1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50008 11.875C10.8118 11.875 11.8751 10.8117 11.8751 9.50002C11.8751 8.18834 10.8118 7.12502 9.50008 7.12502C8.18841 7.12502 7.12508 8.18834 7.12508 9.50002C7.12508 10.8117 8.18841 11.875 9.50008 11.875Z",
    stroke: "#BACCE1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.054dcfb9e44a6ad7a66eafb8452f134b.svg";
export { ForwardRef as ReactComponent };